import React from "react";
import { FaEnvelope, FaPhone } from "react-icons/fa";

const RequestModal = ({ contact, onClose, onChooseSMS, onChooseEmail }) => {
  if (!contact) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center backdrop-blur-md z-50 p-4">
      <div className="bg-white p-6 rounded-md shadow-md w-96">
        <h3 className="text-xl font-semibold mb-4">Send Request</h3>
        <p className="text-gray-600 mb-4">
          Choose how to send feedback request to <b>{contact.name}</b>:
        </p>

        <div className="flex flex-col gap-4">
          {contact.email && (
            <button
              className="bg-blue-500 text-white px-4 py-2 rounded-md flex items-center gap-2"
              onClick={onChooseEmail}
            >
              <FaEnvelope /> Send via Email
            </button>
          )}
          {contact.phone_number && (
            <button
              className="bg-green-500 text-white px-4 py-2 rounded-md flex items-center gap-2"
              onClick={onChooseSMS}
            >
              <FaPhone /> Send via SMS
            </button>
          )}
          {!contact.email && !contact.phone_number && (
            <p className="text-gray-500 text-center">
              No contact method available for this user.
            </p>
          )}
        </div>

        <button
          onClick={onClose}
          className="mt-4 w-full bg-gray-500 text-white px-4 py-2 rounded-md"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default RequestModal;
